import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { iif } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AlertService } from 'src/app/auth/services/alert.service';
import { AddStopMarkerService } from 'src/app/services/add-stop-marker.service';
import { PlaceSetService } from 'src/app/services/place-set.service';
import { FavoriteNameValidator } from 'src/app/_helpers/favorite-name-validator';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { PlaceInfo } from 'src/app/_models/pcmws/favoritePlaces/favoritePlacesResponse';
import { StopLocation } from 'src/app/_models/state/stopState';

@Component({
  selector: 'app-add-favorite-modal',
  templateUrl: './add-favorite-modal.component.html',
})
export class AddFavoriteModalComponent implements OnInit, OnDestroy {
  saveLocationForm: FormGroup;
  private sm = new SubscriptionManager();
  @ViewChild('name') name: ElementRef;
  isLoading = false;
  loading = false;
  submitted = false;
  location: StopLocation;
  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private placeSetService: PlaceSetService,
    private alertService: AlertService,
    private favoriteNameValidator: FavoriteNameValidator,
    private addStopMarkerService: AddStopMarkerService
  ) {}

  ngOnInit(): void {
    this.alertService.clear();
    setTimeout(() => this.name?.nativeElement?.focus());
    this.location = this['initialState'];
    this.saveLocationForm = this.formBuilder.group({
      name: ['', [Validators.required], [this.favoriteNameValidator.validate]],
      isShared: [false],
    });
  }
  get f() {
    return this.saveLocationForm.controls;
  }
  submit() {
    this.isLoading = true;
    this.saveLocationForm.disable();
    // this.submitted = true;
    if (this.saveLocationForm.invalid) {
      return;
    }

    const name = this.f.name.value;
    const shared = this.f.isShared.value;

    this.loading = true;

    this.sm.manage = this.placeSetService
      .getFavoritePlaceSetName(shared)
      .pipe(
        mergeMap((data) =>
          iif(
            () => data.length === 0,
            this.placeSetService.addPlaceSetName(shared).pipe(
              mergeMap((placeSet) => {
                return this.placeSetService.saveNewPlace(this.location, {
                  setId: placeSet?.Id,
                  categoryId: null,
                  shared: shared,
                  name: name,
                } as PlaceInfo);
              })
            ),

            this.placeSetService.saveNewPlace(this.location, {
              setId: data[0]?.Id,
              categoryId: null,
              shared: shared,
              name: name,
            } as PlaceInfo)
          )
        )
      )
      .subscribe(
        (resp) => {
          this.addStopMarkerService.updateMarker({
            ...this.location,
            isFavorite: true,
            isSharedFavorite: shared,
            favoriteId: resp.Id,
            name,
          });
          this.bsModalRef.hide();
        },
        (err) => {
          const errmsg = err?.error?.Description
            ? err.error.Description
            : 'Issue with Save Favorite Place';
          this.alertService.error(
            errmsg,
            false,
            'app-modal-alert.fixedPageAlert'
          );
        }
      );
  }
  ngOnDestroy() {
    this.sm.unsubscribe();
  }
}
